export default {
}



// WEBPACK FOOTER //
// ./src/app/tenant/moving/index/resources/computed.js